import { HStack, VStack } from '@/components/Atoms'
import { getNextTristateValue, TriStateValue } from '@/lib/utils/tristate'
import { INDETERMINATE } from '@repo/constants'
import { Checkbox, Label } from '@repo/ui/components'
import { LucideIcon } from 'lucide-react'
import { Container } from './Container'

export type Option = {
  name: string
  checked: TriStateValue
}

export type TriStateCheckboxListValues = Array<Option>

type TriStateCheckboxListProps = {
  name: string
  title: string
  options: { value: string; label: string; icon?: LucideIcon }[]
  values: TriStateCheckboxListValues
  setValues: React.Dispatch<React.SetStateAction<TriStateCheckboxListValues>>
}

export function TriStateCheckboxList({
  values,
  setValues,
  options,
  title,
}: TriStateCheckboxListProps) {
  const hasOptionSelected = !values.every(
    (o: Option) => o.checked === INDETERMINATE || o.checked === undefined,
  )

  const handleReset = () => {
    setValues(values.map((o: Option) => ({ ...o, checked: undefined })))
  }

  const handleCheckboxChange = ({ name }: Pick<Option, 'name'>) => {
    const updatedValues = values.map((o: Option) =>
      o.name === name ? { ...o, checked: getNextTristateValue(o.checked) } : o,
    )
    setValues(updatedValues)
  }

  return (
    <Container
      isResetVisible={hasOptionSelected}
      onReset={handleReset}
      hasOptionsSelected={hasOptionSelected}
      title={title}
    >
      <VStack gap="md">
        {options.map(({ label, value }) => (
          <HStack gap="md" key={value}>
            <Checkbox
              id={value}
              checked={values.find((o: Option) => o.name === value)?.checked ?? INDETERMINATE}
              onCheckedChange={() => handleCheckboxChange({ name: value })}
            />
            <Label htmlFor={value}>{label}</Label>
          </HStack>
        ))}
      </VStack>
    </Container>
  )
}
